import {registerBlockType} from '@wordpress/blocks';
import {InspectorControls, RichText, useBlockProps} from '@wordpress/block-editor';
import {__} from '@wordpress/i18n';
import MediaHandler from '../components/media-handler';
import {ColorPalette, PanelBody} from '@wordpress/components';
import {useSelect} from '@wordpress/data';

registerBlockType('garden/product-card', {
  apiVersion: 3,
  title: __('Karta produktu', 'garden'),
  icon: 'yes-alt',
  category: 'garden',
  parent: ['garden/products-grid'],
  supports: {
    anchor: true
  },
  attributes: {
    title: {
      type: 'string',
      default: "",
    },
    description: {
      type: 'string',
      default: ''
    },
    mediaUrl: {
      type: 'string',
      default: ''
    },
    mediaAlt: {
      type: 'string',
      default: ''
    },
    backgroundColor: {
      type: 'string',
      default: ''
    },
    textColor: {
      type: 'string',
      default: ''
    },
    anchor: {
      type: 'string',
      default: ''
    }
  },
  edit: ({attributes, setAttributes}) => {
    const {title, description, mediaID, mediaUrl, mediaAlt, backgroundColor, textColor} = attributes;
    const blockProps = useBlockProps();

    const themeColors = useSelect((select) => {
      return select('core/block-editor').getSettings().colors;
    }, []);

    return (
      <>
        <InspectorControls>
          <PanelBody title={__('Ustawienia karty', 'psgarden')}>
            <div className="components-base-control">
              <label className="components-base-control__label">
                {__('Kolor tła', 'psgarden')}
              </label>
              <ColorPalette
                value={backgroundColor}
                onChange={(color) => setAttributes({backgroundColor: color})}
                colors={themeColors}
              />
            </div>
            <div className="components-base-control" style={{marginTop: '1rem'}}>
              <label className="components-base-control__label">
                {__('Kolor tekstu', 'psgarden')}
              </label>
              <ColorPalette
                value={textColor}
                onChange={(color) => setAttributes({textColor: color})}
                colors={themeColors}
              />
            </div>
          </PanelBody>
        </InspectorControls>
        <div {...blockProps}>
          <div className="product-image">
            <MediaHandler
              attributes={{mediaID, mediaUrl, mediaAlt}}
              setAttributes={setAttributes}
              imageSize="medium"
              customButtonLabel={__('Wybierz zdjęcie produktu', 'garden')}
              customRemoveLabel={__('Usuń zdjęcie', 'garden')}
            >
              {mediaUrl
                ? <img src={mediaUrl} alt={mediaAlt}/>
                : <img src="app/themes/psgarden/assets/img/placeholder/robot.png" alt="rysunek przedstawiajacy robota koszącego" style={{
                  display: 'block',
                  width: '15rem',
                  height: '15rem',
                  margin: '0 auto',
                }}/>}
            </MediaHandler>
          </div>
          <div className="product-content" style={{backgroundColor, color: textColor}}>
            <RichText
              tagName="h3"
              className="product-title"
              value={title}
              onChange={(title) => setAttributes({title})}
              placeholder={__('Wprowadź nazwę produktu...', 'garden')}
            />
            <RichText
              tagName="p"
              className="product-description"
              value={description}
              onChange={(description) => setAttributes({description})}
              placeholder={__('Wprowadź opis produktu...', 'garden')}
            />
          </div>
        </div>
      </>
    );
  },
  save: ({attributes}) => {
    const blockProps = useBlockProps.save(
      {
        className: 'wp-block',
      }
    );
    const {title, description, mediaUrl, mediaAlt, backgroundColor, textColor} = attributes;

    return (
      <div {...blockProps}>
        <div className="product-image">
          {mediaUrl && <img src={mediaUrl} alt={mediaAlt}/>}
        </div>
        <div className="product-content" style={{backgroundColor, color: textColor}}>
          <RichText.Content
            tagName="h3"
            className="product-title"
            value={title}
          />
          <RichText.Content
            tagName="p"
            className="product-description"
            value={description}
          />
        </div>
      </div>
    );
  }
}); 
